// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"08c1e9b7","116":"8c8644fe","290":"b66350a4","342":"e0745473","541":"bc7930c7","844":"791fffe3"}[chunkId] + ".chunk.js";
};